import React from 'react'
import { navigate } from 'gatsby'
import { useLocation } from '@reach/router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { Button } from '/src/components/common'

import './mobile_menu.scss'

export default ({ label, route, open, onClickHandler, noChildren }) => {
  const location = useLocation()

  const onClick = () => {
    const { pathname } = location

    if (open) {
      navigate(route)

      if (pathname === route) {
        onClickHandler(false)
      }
    }
    else {
      onClickHandler(route)
    }
  }

  return (
    <div className="mobile-menu-container">
      <ul className="menu">
        <li>
          <Button className="mobile-menu-button" variant="none" onClick={onClick}>
            {label}
            {!noChildren && (
              <FontAwesomeIcon icon={faChevronDown} />
            )}
          </Button>
        </li>
      </ul>
    </div>
  )
}
